module.exports = __webpack_public_path__ + "img/md.md01ec319.svg";